import ApplicationResource from "../../utils/resources.enum";
import {TextFieldsOutlined, WallpaperOutlined} from "@material-ui/icons";
import {QuizAssessmentQuestionList} from "./quiz-assessment-question.list";
import {QuizAssessmentQuestionCreate} from "./quiz-assessment-question.create";
import {QuizAssessmentQuestionEdit} from "./quiz-assessment-question.edit";

export const quizAssessmentQuestionResource = {
  name: ApplicationResource.QUIZ_ASSESSMENT_QUESTION,
  icon: TextFieldsOutlined,
  options: { label: "Questões" },
  link: "/quiz-assessment-question",
  tableName: 'quiz-assessment-question',
  list: QuizAssessmentQuestionList,
  edit: QuizAssessmentQuestionEdit,
  create: QuizAssessmentQuestionCreate,
  products: ['quiz']
}